// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"318":"3982acb7","644":"2968d0ff"}[chunkId] + ".chunk.js";
};